export default "__VITE_ASSET__BtQiZQFd__"